export default {
  name: 'FormDesign',
  props: {
    id: String,
    jsonData: Object || {},
    fieldModels: Array || [],
    dataSourceSet: Array || []
  },
  data: function data() {
    return {
      customFields: [{
        name: '自定义组件',
        el: 'custom-width-height',
        options: {
          defaultValue: {},
          labelWidth: 0,
          isLabelWidth: false,
          hidden: false,
          dataBind: true,
          required: false,
          pattern: '',
          validator: '',
          extendProps: {}
        }
      }, {
        name: '图表示例',
        el: 'custom-chart',
        options: {
          defaultValue: [{
            year: '1951 年',
            sales: 38
          }, {
            year: '1952 年',
            sales: 52
          }, {
            year: '1956 年',
            sales: 61
          }, {
            year: '1957 年',
            sales: 145
          }, {
            year: '1958 年',
            sales: 48
          }, {
            year: '1959 年',
            sales: 38
          }, {
            year: '1960 年',
            sales: 38
          }, {
            year: '1962 年',
            sales: 38
          }],
          customClass: '',
          labelWidth: 100,
          isLabelWidth: false,
          hidden: false,
          dataBind: true,
          required: false,
          pattern: ''
        }
      }, {
        name: 'vant时间选择',
        el: 'custom-vant-field',
        options: {
          defaultValue: '',
          customClass: '',
          labelWidth: 100,
          isLabelWidth: false,
          hidden: false,
          dataBind: true,
          required: false,
          pattern: ''
        }
      }],
      globalConfig: {
        // styleSheets: '.a .el-form-item__label{color: red;}',
        dataSource: [{
          key: 'upload',
          name: 'Get Upload Token',
          url: '/api/flow/approvalUploadFiles',
          method: 'GET',
          auto: true,
          responseFunc: 'return res.uptoken;'
        }, {
          key: 'getoptions',
          name: 'Get Options',
          url: 'https://tools-server.making.link/api/new/options',
          method: 'GET',
          auto: true,
          responseFunc: 'return res.data;'
        }]
      },
      fieldConfig: [{
        type: 'fileupload',
        options: {
          domain: 'http://tcdn.form.making.link/',
          action: '/api/flow/approvalUploadFiles'
        }
      }, {
        type: 'imgupload',
        options: {
          domain: 'http://tcdn.form.making.link/',
          action: '/api/flow/approvalUploadFiles'
        }
      }, {
        type: 'select',
        options: {
          options: [{
            value: '1111'
          }, {
            value: '2222'
          }, {
            value: '3333'
          }]
        }
      }]
    };
  },
  watch: {
    jsonData: {
      // immediate: true,
      handler: function handler(newVal, oldVal) {
        this.handleFormReady(newVal);
      }
    }
  },
  methods: {
    handleGetFormJosnSubmit: function handleGetFormJosnSubmit() {
      var jsonData = this.$refs.generateForm.getJSON();
      //alert(JSON.stringify(jsonData), 'JSON数据')
      return jsonData;
    },
    handleFormReady: function handleFormReady(val) {
      var _this = this;
      this.$nextTick(function () {
        if (Object.prototype.hasOwnProperty.call(_this.jsonData, 'list')) {
          _this.$refs.generateForm.setJSON(_this.jsonData);
        }
      });
    }
  }
};